import {HttpClient, RequestParams} from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {IDonationServiceQuery} from "../../models/donation-service/query";
import {IDonationService, IDonationServiceDetails} from "../../models/donation-service/response";
import {ICreateDonationService, IUpdateDonationService} from "../../models/donation-service/request";

class DonationServiceService<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;

    constructor(http: HttpClient<SecurityDataType>) {
        this.http = http;
    }

    getAllDonationServices = (query: IDonationServiceQuery, params?: RequestParams) =>
        this.http.request<IBaseListingResponse<IDonationService>>({
            path: `/donation-services`,
            method: "GET",
            query,
            ...params,
        });

    getDonationService = (id: number, params?: RequestParams) =>
        this.http.request<IDonationServiceDetails>({
            path: `/donation-services/${id}`,
            method: "GET",
            ...params,
        });

    createDonationService = (data: ICreateDonationService, params?: RequestParams) =>
        this.http.request<IDonationService>({
            path: "/donation-services",
            method: "POST",
            body: data,
            ...params,
        });

    updateDonationService = (id: number, data: IUpdateDonationService, params?: RequestParams) =>
        this.http.request<IDonationService>({
            path: `/donation-services/${id}`,
            method: "PUT",
            body: data,
            ...params,
        });

    deleteDonationService = (id: number, params?: RequestParams) =>
        this.http.request<IDonationService>({
            path: `/donation-services/${id}`,
            method: "DELETE",
            ...params,
        });
}

export default DonationServiceService;